// extracted by mini-css-extract-plugin
module.exports = {"newQuestion":"_1J2Ak21_71c2l0Lj","questionSelector":"_2GX8LdgZROPosM09"};